import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { selectFinSobSidePanelState } from './selectFinSobSidePanelState'

export const selectIsFinSobPanelFetchingData = createSelector(
  [selectFinSobSidePanelState],
  ({ fetchStatus }) => fetchStatus === RequestStatus.PENDING
)
